import { FormControl, TextField } from '@mui/material'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'

export const FormOneRangeEdit = memo((props) => {
  const { setRanges, ranges, range } = props
  const { deleteMode } = useSelector(state => state.contractsCatalog)
  const { min, max, price } = range

  function handleInputOnChange(e) {
    const {name, value} = e.target
    if(name === 'max') {
      if (Number(value) < min) setRanges(ranges.map(item => {
          if (item.id === range.id) return {...item, max: min}
          else return item
        }))
      else setRanges(ranges.map(item => {
          if (item.id === range.id) return {...item, max: Number(value)}
          else return item
        }));
    } else setRanges(ranges.map(item => {
      if (item.id === range.id) return {...item, price: Number(value)}
      else return item
    }));
  }

  return (
    <>
      <FormControl style={{width: '33.3333%'}} variant="outlined">
        <TextField
          disabled={true}
          label="Min:"
          type="number"
          variant="outlined"
          onChange={handleInputOnChange}
          name="min"
          value={min}
        />
      </FormControl>
      <FormControl style={{width: '33.3333%'}} variant="outlined">
        <TextField
          disabled={deleteMode || ranges[ranges.length - 1].id !== range.id}
          label="Max:"
          type="number"
          variant="outlined"
          onChange={handleInputOnChange}
          name="max"
          value={max}
        />
      </FormControl>
      <FormControl style={{width: '33.3333%'}} variant="outlined">
        <TextField
          disabled={deleteMode}
          label="Pago:"
          type="number"
          variant="outlined"
          onChange={handleInputOnChange}
          name="price"
          value={price}
        />
      </FormControl>
    </>
  )
})
